var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "-0.45 -0.45 7 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.27155404,1.9174931 L4.90104076,3.54697982 C5.01366704,3.65960611 5.01366704,3.84172521 4.90104076,3.95315335 L4.6302584,4.2239357 C4.51763212,4.33656199 4.33551301,4.33656199 4.22408488,4.2239357 L3.0678682,3.07011533 L1.91284967,4.22513385 C1.80022338,4.33776014 1.61810428,4.33776014 1.50667614,4.22513385 L1.23469564,3.9543515 C1.12206935,3.84172521 1.12206935,3.65960611 1.23469564,3.54817797 L2.86418236,1.91869125 C2.97680864,1.80486681 3.15892775,1.80486681 3.27155404,1.9174931 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleUp);
export default __webpack_public_path__ + "static/media/angle-up.caf2d5c743b75f8c1f06c461cf82fde3.svg";
export { ForwardRef as ReactComponent };